import isFunction from 'lodash/isFunction';
import reduce from 'lodash/reduce';

/**
 * Maps the given array to an object using the given field for the keys.
 *
 * @param {Array} array
 * @param {string|function} key
 * @return {Object}
 */

export default <T>(
  array: T[],
  key: string | ((field: unknown) => string),
): Record<string, unknown> => {
  const func = isFunction(key);

  return reduce(
    array,
    (acc, valueObject) => {
      if (func && typeof key === 'function') {
        acc[key(valueObject)] = valueObject;
      }

      if (!func && valueObject instanceof Object && typeof key === 'string') {
        acc[valueObject[key as keyof T] as unknown as string] = valueObject;
      }

      return acc;
    },
    {} as Record<string, unknown>,
  );
};
